import {DataService} from '../Services/data.service';
import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {catchError} from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  loggedInName: string;
  name: String;
  password: String;
  loggedIn = false;
  submitted = false;
  error: String;

  constructor(private dataService: DataService, private location: Location, private router: Router) {
  }


  private checkValues() {
    this.dataService.getCurrentPerson().then((response) => {
    }).catch((response) => {

    });
  }

  /**
   * on initializing the page check the PersonName
   */
  ngOnInit(): void {
    this.checkValues();
    this.checkPersonName();
  }

  /**
   * Check if personName is not null
   * If it is null, there will be a redirect to the homepage
   */
  checkPersonName(): void {
    if (this.dataService.personName == null || this.dataService.personName === '') {
      this.router.navigateByUrl('');
    }
  }

  /**
   * login with the username and password
   * Will give error when wrong login
   */
  private login(): void {
    this.dataService.login(this.name, this.password).then((response) => {
      console.log(response);
      this.checkValues();
    }).catch((response) => {
        try {
            response = JSON.parse(response._body);
            console.log(response);
            if (response.status === 401) {
                if (response.message === 'Authentication Failed: New account created with LDAP') {
                    this.login();
                    return true;
                } else {
                    this.error = 'Verkeerde inlog/wachtwoord';
                    this.submitted = false;
                }
            }
        } catch (e) {
            this.error = 'Geen verbinding met server';
            this.submitted = false;
            console.log(e);
        }
    });
  }

  /**
   * on submitting the page use the login function
   */
  onSubmit() {
    if(this.name != '' && this.password != '') {
      if(!this.submitted) {
        this.submitted = true;
        this.login();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts